import React, { useEffect, useState } from "react";
import Select from "react-select";
import Close from "../../Assets/Close.svg";
import RightSidebarStyle from "./style";
import { defaultHeaders } from "../../Redux/Constants/DefaultHeaders";
import Modal from "../Modal";
import axios from "axios";

// -- redux
import { connect } from "react-redux";
import {
  GetTheme,
  DeleteUser,
  EditUser,
  AddUser,
  GetUserServices,
} from "../../Redux/Actions/UserAction";

function RightSideBar(props) {
  const [response, setResponse] = useState(false);
  const [Type, setType] = useState("");
  const [fName, setFName] = useState("");
  const [fNameError, setFNameError] = useState("");
  const [lName, setLName] = useState("");
  const [lNameError, setLNameError] = useState("");
  const [fullName, setFullName] = useState("");
  const [fullNameError, setFullNameError] = useState("");
  const [Email, setEmail] = useState("");
  const [AccNo, setAccNo] = useState("");
  const [AccNoError, setAccNoError] = useState("");
  const [CurrentBalance, setCurrentBalance] = useState("");
  const [CurrentBalanceError, setCurrentBalanceError] = useState("");
  const [Theme, setTheme] = useState("");
  const [ThemeId, setThemeId] = useState();
  const [OpenModal, setModal] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [businessAdmin, setBusinessAdmin] = useState(false);
  const [testUser, setTestUser] = useState(false);
  const [customerServ, setCustomerServ] = useState([]);
  const [businessServ, setBusinessServ] = useState([]);
  const [troubleServ, setTroubleServ] = useState([]);
  const [selectedServiceList, setSelectServiceList] = useState([]);
  const [selectedSecLevelList, setSelectedSecLevelList] = useState([]);
  const [SecLevel, setSecLevel] = useState("");
  const [customServ, setCustomServ] = useState([]);

  useEffect(() => {
    props.theme_data.data &&
      props.theme_data.data.filter((theme) =>
        theme.is_default === 1 ? setThemeId(theme.id) : false
      );
    props.theme_data.data &&
      props.theme_data.data.filter((theme) =>
        theme.is_default === 1 ? setTheme(theme.title) : false
      );

    if (props.data) {
      props.theme_data.data.filter(
        (data) => data.title === props.data.title && setThemeId(data.id)
      );
      setFName(props.data.first_name);
      setLName(props.data.last_name);
      setFullName(props.data.full_name);
      setEmail(props.data.email);
      setAccNo(props.data.primary_account);
      setCurrentBalance(props.data.balance === null ? "" : props.data.balance);
      setTheme(props.data.title);
      setSelectServiceList(props.data.services);
      props.data.user_roles.map((role) => {
        setType(role.role_id);
      });
      setSecLevel(props.data.sec_level);
      setBusinessAdmin(props.data.business_admin);
      setTestUser(props.data.manual_type === 'T');
    }
  }, [props]);

  const TypeOptions = [
    { value: "Personal Banking", label: "Personal Banking", id: 2 },
    { value: "Business", label: "Business", id: 3 },
    { value: "V1be User", label: "V1be User", id: 5 }//,
  ];

  let SecurityOptions = [];

  const BusinessOpts = [
    { value: "Senior Admin", label: "Senior Admin", id: 9 },
    { value: "Sub Admin", label: "Sub Admin", id: 5 },
    { value: "Online Banking", label: "Online Banking", id: 0 },
  ];

  const ConsumerOpts = [
    { value: "Senior Admin", label: "Senior Admin", id: 9 },
    { value: "Online Banking", label: "Online Banking", id: 0 },
  ];

  const colourStyles = {
    control: (styles, state) => ({
      ...styles,
      backgroundColor: "#3C3C3C",
      border: state.isFocused ? "1px solid #A0A0A0" : "1px solid #3C3C3C",
      transition: "all 0.25s linear 0s",
      "&:hover": {
        border: "1px solid #A0A0A0",
      },
      padding: "4px 6px",
      boxShadow: state.isFocused ? null : null,
    }),
    singleValue: (baseStyles, state) => ({
      ...baseStyles,
      color:state.isFocused ? '#ffffff' : '#ffffff',
      backgroundColor: '#3C3C3C'
  }),
  };

  const colourStylesService = {
    control: (styles, state) => ({
      ...styles,
      backgroundColor: "#3C3C3C",
      border: state.isFocused ? "1px solid #A0A0A0" : "1px solid #3C3C3C",
      transition: "all 0.25s linear 0s",
      "&:hover": {
        border: "1px solid #A0A0A0",
      },
      padding: "4px 6px",
      boxShadow: state.isFocused ? null : null,
    }),

    option: (styles, state) => ({
      ...styles,
      backgroundColor: "#3C3C3C",
      color: "#BDFF00",
    }),
  };

  const CloseSidebar = (e) => {
    e.preventDefault();
    setType("");
    setFName("");
    setLName("");
    setFullName("");
    setEmail("");
    setAccNo("");
    setTheme("");
    setCurrentBalance("");
    setEmailError("");
    setSelectServiceList([]);
    setSelectedSecLevelList([]);
    setTestUser(false);
    props.close();
  };

  const getCustomerServList = async () => {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}api/admin/services/0?status=1&user_type=2`,
      {
        headers:  defaultHeaders(),
      }
    );
    if (res.status === 200 && res.data && res.data.data) {
      const list = res.data.data.data;
      const data = list.map((data) => ({ label: data.title, value: data.id }));
      setCustomerServ(data);
    } else {
      // alert(res.data)
    }
  };

  const getTroubleServList = async () => {
    // const res = await axios.get(
    //   `${process.env.REACT_APP_API_URL}api/admin/services/0?status=1&user_type=5`,
    //   {
    //     headers:  defaultHeaders() ,
    //   }
    // );
    // if (res.status === 200 && res.data && res.data.data) {
    //   const list = res.data.data.data;
    //   const data = list.map((data) => ({ label: data.title, value: data.id }));
    //   alert(JSON.stringify(data));
    //   setTroubleServ(data);
    // } else {
    //   // alert(res.data)
    // }

    setTroubleServ([{ label: "Customer Support Form", value: 85 }]);
  };

  const getBusinessServList = async () => {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}api/admin/services/0?status=1&user_type=3`,
      {
        headers:  defaultHeaders() ,
      }
    );
    if (res.status === 200 && res.data && res.data.data) {
      const list = res.data.data.data;
      const data = list.map((data) => ({ label: data.title, value: data.id }));
      setBusinessServ(data);
    } else {
      // alert(res.data)
    }
  };

  const getCustomServList = async () => {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}api/admin/services/0?status=1&user_type=5`,
      {
        headers: defaultHeaders(),
      }
    );
    if (res.status === 200 && res.data && res.data.data) {
      const list = res.data.data.data;
      const data = list.map((data) => ({ label: data.title, value: data.id }));
      setCustomServ(data);
    } else {
      // alert(res.data)
    }
  };

  useEffect(() => {
    getCustomerServList();
    getBusinessServList();
    getCustomServList();
    getTroubleServList();
  }, []);

  const handleModal = (e, type) => {
    e.preventDefault();
    let emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/;
    if (emailRegex.test(Email)) {
      setEmailError("");
      setModal(type);
    } else {
      setEmailError("Invalid email");
      if (type === "delete") {
        setEmailError("");
        setModal(type);
      }
    }
  };

  useEffect(() => {
    setTimeout(function () {
      setResponse(true);
    }, 1000);
  }, []);

  const selectTheme = (selected) => {
    setTheme(selected.label);
    setThemeId(selected.value);
  };

  const CloseModal = (e, type) => {
    e.preventDefault();
    if (type === "delete_yes") {
      props.DeleteUser(props.data.id);
      setModal(false);
    } else if (type === "delete_no") {
      setModal(false);
    } else if (type === "update_yes") {
      const data = {
        id: props.data.id,
        full_name: fullName,
        first_name: fName,
        last_name: lName,
        primary_account: AccNo,
        user_type: Type,
        balance: CurrentBalance,
        email: Email,
        theme_id: ThemeId,
        user_services: selectedServiceList
          .map((item) => {
            return item.value;
          })
          .toString(),
          sec_level: SecLevel,
          business_admin: businessAdmin,
          test_user: testUser, 
      };
      props.EditUser(data);
      setModal(false);
    } else if (type === "add_yes") {
      const data = {
        full_name: fullName,
        first_name: fName,
        last_name: lName,
        primary_account: AccNo,
        user_type: Type,
        balance: CurrentBalance,
        email: Email,
        theme_id: ThemeId,
        user_services: selectedServiceList
          .map((item) => {
            return item.value;
          })
          .toString(),
        sec_level: SecLevel,
        business_admin: businessAdmin,
        test_user: testUser,
      };
      //alert(JSON.stringify(data))
      props.AddUser(data);
      setType("");
      setFName("");
      setLName("");
      setFullName("");
      setEmail("");
      setAccNo("");
      setTheme("");
      setCurrentBalance("");
      setSecLevel([]);
      setSelectServiceList([]);
      setBusinessAdmin(false);
      props.close();
      setModal(false);
    } else if (type === "add_no") {
      setModal(false);
    } else {
      setModal(false);
    }
  };

  const renderList = () => {
    return (
      props.theme_data.data &&
      props.theme_data.data.map((data) => ({
        label: data.title,
        value: data.id,
      }))
    );
  };

  const renderSecLevel = (id) => {
    swapSecLevel();
    return (
      SecurityOptions.map((data) => ({
        label: data.label,
        value: data.id,
      }))
    );
  };

  const swapSecLevel = () => {
    
    if(Type === 2)
    {
      SecurityOptions = ConsumerOpts;
    }
    else if(Type === 3)
    {
      SecurityOptions = BusinessOpts;
    }
    else if(Type === 5)
    {
      SecurityOptions = BusinessOpts;
    }
    else {
      
      SecurityOptions = []
    }
  };

 
  const renderServices = () => {
    return (
      props.user_services &&
      props.user_services.data &&
      props.user_services.data.map((data) => ({
        label: data.title,
        value: data.id,
      }))
    );
  };

  const handleServices = (selected) => {
    setSelectServiceList(selected);
  };

  const handleAccNo = (e) => {
    if (e.target.value.length < 16 || e.target.value.length === 16) {
      setAccNo(e.target.value);
      setAccNoError("");
    } else {
      setAccNoError("Account number can not be more than 16 characters");
    }
  };

  const handlefName = (e) => {
    if (e.target.value.length < 20 || e.target.value.length === 20) {
      setFName(e.target.value);
      setFNameError("");
    } else {
      setFNameError("First Name can not be more than 20 characters");
    }
  };

  const handlelName = (e) => {
    if (e.target.value.length < 20 || e.target.value.length === 20) {
      setLName(e.target.value);
      setLNameError("");
    } else {
      setLNameError("Last Name can not be more than 20 characters");
    }
  };

  const handleFullName = (e) => {
    if (e.target.value.length < 50 || e.target.value.length === 50) {
      setFullName(e.target.value);
      setFullNameError("");
    } else {
      setFullNameError("Full Name can not be more than 50 characters");
    }
  };

  const handleBalance = (e) => {
    if (e.target.value.length < 15 || e.target.value.length === 15) {
      setCurrentBalance(e.target.value);
      setCurrentBalanceError("");
    } else {
      setCurrentBalanceError(
        "Current balance can not be more than 15 characters"
      );
    }
  };

  useEffect(() => {
    props.edit_data &&
      response &&
      props.response({
        type: props.edit_data.status,
        message: props.edit_data.message,
      });
  }, [props.edit_data]);

  useEffect(() => {
    props.delete_data &&
      response &&
      props.response({
        type: props.delete_data.status,
        message: props.delete_data.message,
      });
  }, [props.delete_data]);

  useEffect(() => {
    props.add_data &&
      response &&
      props.response({
        type: props.add_data.status,
        message: props.add_data.message,
      });
  }, [props.add_data]);

  const handleUserAdmin = (e,admin) => {
    e.preventDefault();
    setBusinessAdmin(! admin);
  };

  const handleTestUser = (e,tester) => {
    e.preventDefault();
    setTestUser(! tester);
  };

  return (
    <>
      {props && props.sidebar && (
        <div onClick={(e) => CloseSidebar(e)} className="dark-overlay" />
      )}
      <div
        className={
          props && props.sidebar
            ? "dark-background right-sidebar-wrap"
            : "dark-background right-sidebar-wrap right-sidebar-wrap-close"
        }
      >
        <div className="d-flex justify-content-between align-items-center">
          <h5 className="text-uppercase text-white">{props.Type} USER</h5>
          <img
            onClick={(e) => CloseSidebar(e)}
            src={Close}
            alt="Close"
            className="cursor-pointer"
          />
        </div>
        <form
          className="sidebar-form-wrap"
          id="SidebarForm-user"
          autoComplete="off"
        >
          <div>
              <label htmlFor="BA" className="text-grey-6 f-16 d-block mb-1">
                    Testing User
              </label>
              <p className=
                {
                  testUser
                    ? "text-green label-para f-12"
                    : "text-grey label-para f-12"
                }
              >
              </p>
              <label className="switch mb-0">
                <input
                  type="checkbox"
                  checked={testUser}
                  readOnly
                />
                <span
                  className="slider round"
                  onClick={(e) =>
                    handleTestUser(e,testUser)
                  }
                />
              </label>
              
            </div>
          <div className="mt-4">
            <label htmlFor="type" className="text-grey-6 f-16 d-block mb-1">
              Type <span className="text-danger">*</span>
            </label>
            <Select
              isSearchable={false}
              onChange={(selected) => {
                setSelectedSecLevelList([]);
                setType(selected.id);
                renderSecLevel(selected.id);
                setSecLevel("");
                setBusinessAdmin(false);
              }}
              options={TypeOptions}
              styles={colourStyles}
              placeholder="Select Type"
              value={
                TypeOptions.filter(function (option) {
                  return option.id === Type;
                }) || ""
              }
              id="type"
            />
          </div>
          {(<div className="mt-4">
            <label htmlFor="type" className="text-grey-6 f-16 d-block mb-1">
              Security Level <span className="text-danger">*</span>
            </label>
            <Select
              isSearchable={false}
              onChange={(selected) => {
                setBusinessAdmin(false);
                if (Type === 2 && selected.value === 9) {
                  setSelectServiceList(customerServ);
                } else if (Type === 3 && selected.value === 9) {
                  setSelectServiceList(businessServ);
                } else if (Type === 5 && selected.value === 9) {
                  setSelectServiceList(customServ);
                }
                else {
                  setSelectServiceList(troubleServ);
                }
                setSecLevel(selected.value);
                if(selected.value === 5)
                  setCurrentBalance("See online banking.");
              }}
              options={renderSecLevel()}
              styles={colourStyles}
              placeholder="Select Type"
              value={
                SecurityOptions.filter(function (option) {
                  return option.id === SecLevel;
                }) || ""
              }
              id="secLevel"
            />
          </div>)}
          <div className="mt-4">
          {(Type === 3 || Type === 5) && SecLevel === 9 && (
            <div>
              <label htmlFor="BA" className="text-grey-6 f-16 d-block mb-1">
                    User Administrator 
              </label>
              <p className=
                {
                  businessAdmin
                    ? "text-green label-para f-12"
                    : "text-grey label-para f-12"
                }
              >
              </p>
              <label className="switch mb-0">
                <input
                  type="checkbox"
                  checked={businessAdmin}
                  readOnly
                />
                <span
                  className="slider round"
                  onClick={(e) =>
                    handleUserAdmin(e,businessAdmin)
                  }
                />
              </label>
              
            </div>
            
            )}
          </div>

          <div className="mt-4">
            <label htmlFor="fName" className="text-grey-6 f-16 d-block mb-1">
              First Name <span className="text-danger">*</span>
            </label>
            <input
              value={fName}
              onChange={(e) => handlefName(e)}
              type="text"
              id="fName"
              placeholder="Enter First Name"
              className="w-100 input-style"
              autoComplete="off"
            />
            {fNameError && <p className="f-12 text-danger">{fNameError}</p>}
          </div>
          <div className="mt-4">
            <label htmlFor="lName" className="text-grey-6 f-16 d-block mb-1">
              Last Name <span className="text-danger">*</span>
            </label>
            <input
              value={lName}
              onChange={(e) => handlelName(e)}
              type="text"
              id="lName"
              placeholder="Enter Last Name"
              className="w-100 input-style"
              autoComplete="off"
            />
            {lNameError && <p className="f-12 text-danger">{lNameError}</p>}
          </div>
          <div className="mt-4">
            <label htmlFor="FullName" className="text-grey-6 f-16 d-block mb-1">
              Full Name <span className="text-danger">*</span>
            </label>
            <input
              value={fullName}
              onChange={(e) => handleFullName(e)}
              type="text"
              id="FullName"
              placeholder="Enter Full Name"
              className="w-100 input-style"
              autoComplete="off"
            />
            {fullNameError && (
              <p className="f-12 text-danger">{fullNameError}</p>
            )}
          </div>
          <div className="mt-4">
            <label htmlFor="email" className="text-grey-6 f-16 d-block mb-1">
              Email Address <span className="text-danger">*</span>
            </label>
            <input
              value={Email}
              onChange={(e) => setEmail(e.target.value)}
              type="text"
              id="email"
              placeholder="Enter Email Address"
              className="w-100 input-style"
              autoComplete="off"
            />
            {emailError && (
              <span className="f-12 text-danger">{emailError}</span>
            )}
          </div>
          <div className="mt-4">
            <label
              htmlFor="account_no"
              className="text-grey-6 f-16 d-block mb-1"
            >
              Account Number{" "}
              {Type === 5 ? "" : <span className="text-danger">*</span>}
            </label>
            <input
              value={AccNo}
              onChange={(e) => handleAccNo(e)}
              type="text"
              id="account_no"
              placeholder="Enter Account Number"
              className="w-100 input-style"
              autoComplete="off"
              onKeyDown={(evt) =>
                ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()
              }
              disabled={SecLevel === 5 && props.Type != "Add"}
            />
            {AccNoError && <p className="f-12 text-danger">{AccNoError}</p>}
          </div>
          <div className="mt-4">
            <label
              htmlFor="current_balance"
              className="text-grey-6 f-16 d-block mb-1"
            >
              Current balance{" "}
              {Type === 5 ? "" : <span className="text-danger">*</span>}
            </label>
            <input
              value={
                CurrentBalance
                  ? CurrentBalance.replace(",", "").replace("$", "")
                  : SecLevel === 5 ? "See online banking." : ""
              }
              onChange={(e) => handleBalance(e)}
              disabled={SecLevel === 5}
              type="text"
              id="current_balance"
              placeholder="Enter Current Balance"
              className="w-100 input-style"
              autoComplete="off"
              onKeyDown={(evt) =>
                ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()
              }
              maxLength="15"
            />
            {CurrentBalanceError && (
              <p className="f-12 text-danger">{CurrentBalanceError}</p>
            )}
          </div>
          <div className="mt-4">
            <label className="text-grey-6 f-16 d-block mb-1">
              Current Theme{" "}
              {Type === 5 ? "" : <span className="text-danger">*</span>}
            </label>
            {props.theme_data.data && props.Type === "Edit" && (
              <Select
                isSearchable={false}
                value={
                  renderList().filter(function (option) {
                    return option.label === Theme;
                  }) || ""
                }
                onChange={(selected) => selectTheme(selected)}
                options={renderList()}
                styles={colourStyles}
                placeholder="Select Theme"
              />
            )}
            {renderList() && props.Type === "Add" && (
              <Select
                value={
                  renderList().filter(function (option) {
                    return option.label === Theme;
                  }) || ""
                }
                onChange={(selected) => selectTheme(selected)}
                options={renderList()}
                styles={colourStyles}
                placeholder="Select Theme"
              />
            )}
          </div>{" "}
          {
            <div className="mt-4 serviceDropDown">
              <label className="text-grey-6 f-16 d-block mb-1">
                Services <span className="text-danger">*</span>
              </label>
              {props.user_services.data && props.Type === "Edit" && (
                <Select
                  value={selectedServiceList}
                  options={renderServices()}
                  blurInputOnSelect={false}
                  onChange={(selected) => handleServices(selected)}
                  maxMenuHeight={250}
                  closeMenuOnSelect={false}
                  styles={colourStylesService}
                  autoBlur={true}
                  isMulti={true}
                  // components={{ Option: ServiceOption }}
                  placeholder="Select Services"
                />
              )}
              {props.user_services && props.Type === "Add" && (
                <Select
                  value={selectedServiceList}
                  maxMenuHeight={250}
                  autoBlur={true}
                  closeMenuOnSelect={false}
                  blurInputOnSelect={false}
                  onChange={(selected) => handleServices(selected)}
                  options={renderServices()}
                  // components={{ Option: ServiceOption }}
                  isMulti={true}
                  styles={colourStylesService}
                  placeholder="Select Services"
                />
              )}
            </div>
          }
          <div className="mt-5 mb-5 text-center">
            {props.Type === "Add" && (
              <button
                onClick={(e) => handleModal(e, "add")}
                className="form-button"
                disabled={
                  Type === 5 ? !(Type && fName && lName && fullName && Email && selectedServiceList.length > 0)
                    : !(
                        Type &&
                        fName &&
                        lName &&
                        fullName &&
                        Email &&
                        CurrentBalance &&
                        AccNo &&
                        Theme && selectedServiceList.length > 0
                      )
                }
              >
                Save
              </button>
            )}
            {props.Type === "Edit" && (
              <div className="d-flex align-items-center justify-content-center">
                <button
                  onClick={(e) => handleModal(e, "delete")}
                  className="form-button form-button-ghost f-14 mr-2"
                >
                  Delete
                </button>
                <button
                  disabled={
                    Type === 5  ? !(Type && fName && lName && fullName && Email && selectedServiceList.length > 0)
                      : !(
                          Type &&
                          fName &&
                          lName &&
                          fullName &&
                          Email &&
                          CurrentBalance &&
                          AccNo &&
                          Theme && selectedServiceList.length > 0
                        )
                  }
                  onClick={(e) => handleModal(e, "update")}
                  className="form-button ml-2 f-14"
                >
                  Update
                </button>
              </div>
            )}
          </div>
        </form>
      </div>
      {OpenModal && (
        <Modal
          Name={fName + " " + lName}
          Type={OpenModal}
          Close={(e, type) => CloseModal(e, type)}
        />
      )}
      <RightSidebarStyle />
    </>
  );
}

const mapStateToProps = ({ GetUserReducer }) => {
  const {
    loading,
    theme_data,
    delete_data,
    add_data,
    edit_data,
    user_services,
  } = GetUserReducer;
  return {
    loading,
    theme_data,
    delete_data,
    add_data,
    edit_data,
    user_services,
  };
};

const mapDispatchToProps = {
  GetTheme,
  DeleteUser,
  EditUser,
  AddUser,
  GetUserServices,
};

export default connect(mapStateToProps, mapDispatchToProps)(RightSideBar);
